import React from 'react';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { SURVEY_VIEW_GET_FORM, SURVEY_UPT_PAGE_VISIBLE, GET_ANS, UPT_ANS, CLR_QUES_1, CLR_QUES_2 } from '../actions';

import { getSurveyViewSuccess, getSurveyViewError, getAnsSuccess, getAnsError } from './actions';
import {
  apiview_endpoint,
  adminRoot,
  basename,
} from '../../constants/defaultValues';
import axios from 'axios';
import surveyViewData from '../surveyview.json';

const getAnsLnk = (survey) => {
  var existapi = null; 
  const url = new URL(window.location.href);
  const c = url.searchParams.get('_f');
  const vfy = url.searchParams.get('vfy');
  const pre = url.searchParams.get('_p');
  const ref = url.searchParams.get('_mref');
  const agent = url.searchParams.get('_agent');
  const chl = url.searchParams.get('_channel');

  if (pre !== null && pre === "2") {
    const addResponse = {
      pages: []
    }
  
    if (ref !== '' && ref !== null) {
      addResponse._mref = ref
    }
    if (agent !== '' && agent !== null) {
      addResponse._agent = agent
    }
    if (chl !== '' && chl !== null) {
      addResponse._channel = chl
    }
    for (let p = 0; p < survey.pages.length; p += 1) {
      addResponse.pages.push({
        id: survey.pages[p].id,
        questions: []
      });
      for (let q = 0; q < survey.pages[p].questions.length; q += 1) {
        if (survey.pages[p].questions[q].family.id !== 7) {
          if (survey.pages[p].questions[q].family.id === 3) {
            const obj = [];
            for (let c = 0; c < survey.pages[p].questions[q].choices.length; c += 1) {
              obj.push({
                choiceid: survey.pages[p].questions[q].choices[c].id,
                value: false,
              })
            }
            if (survey.pages[p].questions[q].other.enabled === true) {
              obj.push({
                choiceid: survey.pages[p].questions[q].other.id,
                value: false,
                other: ''
              })
            }
            addResponse.pages[p].questions.push({
              id: survey.pages[p].questions[q].id,
              family: survey.pages[p].questions[q].family,
              subtype: survey.pages[p].questions[q].subtype,
              answer: obj
            });
          } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 1) {
            const obj = [];
            for (let c = 0; c < survey.pages[p].questions[q].rowes.length; c += 1) {
              obj.push({
                rowid: survey.pages[p].questions[q].rowes[c].id,
                choiceid: '',
              })
            }
            addResponse.pages[p].questions.push({
              id: survey.pages[p].questions[q].id,
              family: survey.pages[p].questions[q].family,
              subtype: survey.pages[p].questions[q].subtype,
              answer: obj
            });
          } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 2) {
            const obj = [];
            for (let r = 0; r < survey.pages[p].questions[q].rowes.length; r += 1) {
              const choiceobj = [];
              for (let c = 0; c < survey.pages[p].questions[q].choices.length; c += 1) {
                choiceobj.push({
                  choiceid: survey.pages[p].questions[q].choices[c].id,
                  value: false,
                })
              }
              obj.push({
                rowid: survey.pages[p].questions[q].rowes[r].id,
                choices: choiceobj,
              })
            }
            addResponse.pages[p].questions.push({
              id: survey.pages[p].questions[q].id,
              family: survey.pages[p].questions[q].family,
              subtype: survey.pages[p].questions[q].subtype,
              answer: obj
            });
          } else {
            addResponse.pages[p].questions.push({
              id: survey.pages[p].questions[q].id,
              family: survey.pages[p].questions[q].family,
              subtype: survey.pages[p].questions[q].subtype,
              answer: {}
            });
          }
        } else {
          addResponse.pages[p].questions.push({
            id: survey.pages[p].questions[q].id,
            family: survey.pages[p].questions[q].family,
            subtype: survey.pages[p].questions[q].subtype,
          });
        }
      }
    }
    existapi = addResponse;
  } else {
    if (existapi === null) {
      const addResponse = {
        _f: survey._f,
        _r: survey._r,
        _i: parseInt(atob(vfy)),
        _e: survey._e,
        respondentStartDatetime: survey.respondentStartDatetime,
        pages: []
      }
      if (pre !== null && pre !== '') {
        addResponse._p = parseInt(pre)
      }
    
      if (ref !== '' && ref !== null) {
        addResponse._mref = ref
      }
      if (agent !== '' && agent !== null) {
        addResponse._agent = agent
      }
      if (chl !== '' && chl !== null) {
        addResponse._channel = chl
      }
      for (let p = 0; p < survey.pages.length; p += 1) {
        addResponse.pages.push({
          id: survey.pages[p].id,
          questions: []
        });
        for (let q = 0; q < survey.pages[p].questions.length; q += 1) {
          if (survey.pages[p].questions[q].family.id !== 7) {
            if (survey.pages[p].questions[q].family.id === 3) {
              const obj = [];
              for (let c = 0; c < survey.pages[p].questions[q].choices.length; c += 1) {
                obj.push({
                  choiceid: survey.pages[p].questions[q].choices[c].id,
                  value: false,
                })
              }
              if (survey.pages[p].questions[q].other.enabled === true) {
                obj.push({
                  choiceid: survey.pages[p].questions[q].other.id,
                  value: false,
                  other: ''
                })
              }
              addResponse.pages[p].questions.push({
                id: survey.pages[p].questions[q].id,
                family: survey.pages[p].questions[q].family,
                subtype: survey.pages[p].questions[q].subtype,
                answer: obj
              });
            } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 1) {
              const obj = [];
              for (let c = 0; c < survey.pages[p].questions[q].rowes.length; c += 1) {
                obj.push({
                  rowid: survey.pages[p].questions[q].rowes[c].id,
                  choiceid: '',
                })
              }
              addResponse.pages[p].questions.push({
                id: survey.pages[p].questions[q].id,
                family: survey.pages[p].questions[q].family,
                subtype: survey.pages[p].questions[q].subtype,
                answer: obj
              });
            } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 2) {
              const obj = [];
              for (let r = 0; r < survey.pages[p].questions[q].rowes.length; r += 1) {
                const choiceobj = [];
                for (let c = 0; c < survey.pages[p].questions[q].choices.length; c += 1) {
                  choiceobj.push({
                    choiceid: survey.pages[p].questions[q].choices[c].id,
                    value: false,
                  })
                }
                obj.push({
                  rowid: survey.pages[p].questions[q].rowes[r].id,
                  choices: choiceobj,
                })
              }
              addResponse.pages[p].questions.push({
                id: survey.pages[p].questions[q].id,
                family: survey.pages[p].questions[q].family,
                subtype: survey.pages[p].questions[q].subtype,
                answer: obj
              });
            } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 3) {
              const obj = [];
              for (let r = 0; r < survey.pages[p].questions[q].rowes.length; r += 1) {
                const choiceobj = [];
                for (let c = 0; c < survey.pages[p].questions[q].choices.length; c += 1) {
                  choiceobj.push({
                    choiceid: survey.pages[p].questions[q].choices[c].id,
                    value: '',
                  })
                }
                obj.push({
                  rowid: survey.pages[p].questions[q].rowes[r].id,
                  choices: choiceobj,
                })
              }
              addResponse.pages[p].questions.push({
                id: survey.pages[p].questions[q].id,
                family: survey.pages[p].questions[q].family,
                subtype: survey.pages[p].questions[q].subtype,
                answer: obj
              });
            } else {
              addResponse.pages[p].questions.push({
                id: survey.pages[p].questions[q].id,
                family: survey.pages[p].questions[q].family,
                subtype: survey.pages[p].questions[q].subtype,
                answer: {}
              });
            }
          } else {
            addResponse.pages[p].questions.push({
              id: survey.pages[p].questions[q].id,
              family: survey.pages[p].questions[q].family,
              subtype: survey.pages[p].questions[q].subtype,
            });
          }
        }
      }
      existapi = addResponse;
    }
  }
  return existapi;
}

const getSurveyViewRequest = () => {
  const url = new URL(window.location.href);
  const fid = url.searchParams.get('_f');
  const iid = url.searchParams.get('vfy');
  const pref = url.searchParams.get('_p');

  const ref = url.searchParams.get('_mref');
  const agent = url.searchParams.get('_agent');
  const chl = url.searchParams.get('_channel');
  return axios.post(apiview_endpoint + '/surveyRespondent/' + atob(iid) + '/' + fid, {}, {   headers: {'Authorization': 'bearer ' + localStorage.getItem('gpfkey')}})
    .then(function (response) {
      let apians = null;
      surveyViewData.data[0] = response.data.data[0];
      if(response.data.answer !== undefined) {
        if (Object.keys(response.data.answer).length == 0 || pref === "2") {
          apians = getAnsLnk(response.data.data[0])
        } else {
          apians = response.data.answer
          if (ref !== '' && ref !== null) {
            apians._mref = ref
          }
          if (agent !== '' && agent !== null) {
            apians._agent = agent
          }
          if (chl !== '' && chl !== null) {
            apians._channel = chl
          }
        }
      } else {
        apians = getAnsLnk(response.data.data[0])
      }
      const temp = {
        svy: surveyViewData.data[0],
        ansdata: apians
      }
      return temp
      // return surveyViewData.data[0]
    }).catch(function (error) {

      if (error.response) {
        // Request made and server responded
        // console.log(error.response.data.message);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        return { error: true, errorMessage: error.response.data.message }
      } else if (error.request) {
        // The request was made but no response was received
        // console.log(error.request);
        return { error: true, errorMessage: error.request }
      } else {
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
        return { error: true, errorMessage: error.message }
      }
      // throw ers;
      // reject(false);
      return false;
    });
};


function* getSurveyViewItems() {
  try {
    const response = yield call(getSurveyViewRequest);
    if (response.error) {
      yield put(getSurveyViewError({ error: true, errorMessage: response.errorMessage }))
    } else {
      yield put(getSurveyViewSuccess(response))
    }
  } catch (error) {
    yield put(getSurveyViewError({ error: true, message: "" }));
  }
}

const ClearAllQues = async (start, end, survey, answer) => {
  return await new Promise((success) => {
    let arr = answer;
    let suredit = survey;
    for (let p = start + 1; p < end; p += 1) {
      let active = false;
      for (let q = 0; q < survey.pages[p].questions.length; q += 1) {
        if (survey.pages[p].questions[q].family.id !== 7) {
          if (survey.pages[p].questions[q].family.id === 3) {
            for (let c = 0; c < arr.pages[p].questions[q].answer.length; c += 1) {
              arr.pages[p].questions[q].answer[c].value = false;
              if (survey.pages[p].questions[q].other.enabled === true && arr.pages[p].questions[q].answer[c].other !== undefined) {
                arr.pages[p].questions[q].answer[c].other = '';
              }
              if (arr.pages[p].questions[q].answer[c].option !== undefined) {
                delete arr.pages[p].questions[q].answer[c].option
              }
            }
          } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 1) {
            for (let c = 0; c < survey.pages[p].questions[q].rowes.length; c += 1) {
              arr.pages[p].questions[q].answer[c].choiceid = '';
            }
          } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 2) {
            for (let c = 0; c < survey.pages[p].questions[q].rowes.length; c += 1) {
              for (let l = 0; l < survey.pages[p].questions[q].choices.length; l += 1) {
                arr.pages[p].questions[q].answer[c].choices[l].value = false;
              }
            }
          } else if (survey.pages[p].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 3) {
            for (let c = 0; c < survey.pages[p].questions[q].rowes.length; c += 1) {
              for (let l = 0; l < survey.pages[p].questions[q].choices.length; l += 1) {
                arr.pages[p].questions[q].answer[c].choices[l].value = '';
              }
            }
          } else {
            arr.pages[p].questions[q].answer = {};
          }
        } 
        const url = new URL(window.location.href);
        const pref = url.searchParams.get('_p');
      
        if (!(pref != null && pref == '2')) {
          if (survey.pages[p].questions[q].addtarget === true && active == false) {
            suredit.pages[p].questions[q].visible = true;
            active = true
          } else if (active == true) {
            suredit.pages[p].questions[q].visible = false;
          } else {
            suredit.pages[p].questions[q].visible = true;
          }
        }
      }
    }
    success({ans : arr, sur: suredit});
  })
    .then((response) => response)
    .catch((error) => error);
}
const ClearSomeQues = async (pagei, start, end, survey, answer) => {
  return await new Promise((success) => {
    let arr = answer;
    for (let q = start + 1; q < end; q += 1) {
      if (survey.pages[pagei].questions[q].family.id !== 7) {
        if (survey.pages[pagei].questions[q].family.id === 3) {
          for (let c = 0; c < arr.pages[pagei].questions[q].answer.length; c += 1) {
            arr.pages[pagei].questions[q].answer[c].value = false;
            if (survey.pages[pagei].questions[q].other.enabled === true && arr.pages[pagei].questions[q].answer[c].other !== undefined) {
              arr.pages[pagei].questions[q].answer[c].other = '';
            }
            if (arr.pages[pagei].questions[q].answer[c].option !== undefined) {
              delete arr.pages[pagei].questions[q].answer[c].option
            }
          }
        } else if (survey.pages[pagei].questions[q].family.id === 5 && survey.pages[pagei].questions[q].subtype.id === 1) {
          for (let c = 0; c < survey.pages[pagei].questions[q].rowes.length; c += 1) {
            arr.pages[pagei].questions[q].answer[c].choiceid = '';
          }
        } else if (survey.pages[pagei].questions[q].family.id === 5 && survey.pages[pagei].questions[q].subtype.id === 2) {
          for (let c = 0; c < survey.pages[pagei].questions[q].rowes.length; c += 1) {
            for (let l = 0; l < survey.pages[pagei].questions[q].choices.length; l += 1) {
              arr.pages[pagei].questions[q].answer[c].choices[l].value = false;
            }
          }
        } else if (survey.pages[pagei].questions[q].family.id === 5 && survey.pages[p].questions[q].subtype.id === 3) {
          for (let c = 0; c < survey.pages[pagei].questions[q].rowes.length; c += 1) {
            for (let l = 0; l < survey.pages[pagei].questions[q].choices.length; l += 1) {
              arr.pages[p].questions[q].answer[c].choices[l].value = '';
            }
          }
        } else {
          arr.pages[pagei].questions[q].answer = {};
        }
      }
    }
    success({ans: arr, sur: survey});
  })
    .then((response) => response)
    .catch((error) => error);
}

const updateFormObj = (formid, payload) => {
  for (let i = 0; i < surveyViewData.data.length; i += 1) {
    try {
      if (surveyViewData.data[i].id === formid) {
        surveyViewData.data[i] = payload;
      }
    } catch (err) {
      window.location.href = basename + adminRoot + '/survey';
    }
  }
};

const updAnsObj = async (payload) => {
  return await new Promise((success) => {
    success(payload);
  })
    .then((response) => response)
    .catch((error) => error);
};
const uptFormreq = async (id, obj) => {
  // eslint-disable-next-line no-return-await
  updateFormObj(id, obj);
  return obj;
};
function* uptForm({ payload }) {
  try {
    const { id, items } = payload;
    const response = yield call(uptFormreq, id, items);
    yield put(getSurveyViewSuccess(response));
  } catch (error) {
    yield put(getSurveyViewError(error));
  }
}


function* getAnsItems({ payload }) {
  try {
    const response = yield call(getAnsRequest, payload);
    yield put(getAnsSuccess(response));
  } catch (error) {
    yield put(getAnsError(error));
  }
}

function* uptAns({ payload }) {
  try {
    const response = yield call(updAnsObj, payload);
    yield put(getAnsSuccess(response));
  } catch (error) {
    yield put(getAnsError(error));
  }
}

function* ClearAllQuesReq({ payload }) {
  try {
    const { start, end, survey, answer } = payload;
    const response = yield call(ClearAllQues, start, end, survey, answer);
    yield put(getAnsSuccess(response));
  } catch (error) {
    yield put(getAnsError(error));
  }
}

function* ClearSomeQuesReq({ payload }) {
  try {
    const { pi, start, end, survey, answer } = payload;
    const response = yield call(ClearSomeQues, pi, start, end, survey, answer);
    yield put(getAnsSuccess(response));
  } catch (error) {
    yield put(getAnsError(error));
  }
}

export function* watchGetView() {
  yield takeEvery(SURVEY_VIEW_GET_FORM, getSurveyViewItems);
}
export function* watchUptFormForView() {
  yield takeEvery(SURVEY_UPT_PAGE_VISIBLE, uptForm);
}
export function* watchAns() {
  yield takeEvery(GET_ANS, getAnsItems);
}
export function* watchuptAns() {
  yield takeEvery(UPT_ANS, uptAns);
}

export function* watchClearAllQues() {
  yield takeEvery(CLR_QUES_1, ClearAllQuesReq);
}
export function* watchClearSomeQues() {
  yield takeEvery(CLR_QUES_2, ClearSomeQuesReq);
}

export default function* rootSaga() {
  yield all([fork(watchGetView), fork(watchUptFormForView), fork(watchAns), fork(watchuptAns), fork(watchClearAllQues), fork(watchClearSomeQues)]);
}
